import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import { usePageTransition } from '../../utils/pageTransitions';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import CompanyStory from './components/CompanyStory';
import TeamSection from './components/TeamSection';
import CertificationsSection from './components/CertificationsSection';
import ValuesSection from './components/ValuesSection';
import CSRSection from './components/CSRSection';
import AwardsSection from './components/AwardsSection';
import CTASection from './components/CTASection';

const AboutOrazek = () => {
  const { variants, transition } = usePageTransition();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>À Propos de ORAZEK - Notre Histoire et Notre Vision</title>
        <meta name="description" content="Découvrez ORAZEK Investment, votre partenaire de confiance en RDC. Notre mission : stimuler la croissance sécurisée et l'innovation à travers des solutions multisectorielles." />
      </Helmet>
      <div className="min-h-screen bg-white dark:bg-slate-900">
        <Header />
        <motion.main
          className="main-content"
          initial="initial"
          animate="animate"
          exit="exit"
          variants={variants}
          transition={transition}
        >
          <HeroSection />
          <CompanyStory />
          <ValuesSection />
          <TeamSection />
          <CertificationsSection />
          <AwardsSection />
          <CSRSection />
          <CTASection />
        </motion.main>
        <Footer />
      </div>
    </>
  );
};

export default AboutOrazek;